import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2, Link } from '@zola/zola-ui';

import './ChecklistSaveCancelButtons.less';

const ChecklistSaveCancelButtons = ({ onSave, onCancel }) => (
  <div className="checklist__save-cancel--container">
    <ButtonV2 type="submit" onClick={onSave} className="checklist__button--save">
      Save
    </ButtonV2>
    <Link onClick={onCancel} className="checklist__button--cancel">
      Cancel
    </Link>
  </div>
);

ChecklistSaveCancelButtons.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
};

export default ChecklistSaveCancelButtons;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistSaveCancelButtons/ChecklistSaveCancelButtons.jsx